import I18n from 'i18n-js';
import fr from './fr.json';

export default function (defaultLocale = 'fr') {
  I18n.fallbacks = true;
  I18n.defaultLocale = defaultLocale;
  I18n.translations = { fr };
}



// WEBPACK FOOTER //
// ./src/translations/index.js